<main>
  <section class="seccion-lista position-relative">
    <div class="sticky-top mb-1">
      <div class="tarjeta-resumen productos p-2">
        <div class="d-flex justify-content-between">
          <div class="bloque-izquierdo">
            <span class="label-compras-numero">Historial de compras</span>
          </div>
          <div>
            <button class="boton-finalizar-accion p-2" (click)="volver()">Volver</button>
          </div>
        </div>
      </div>
    </div>

    <div *ngFor="let grupo of comprasAgrupadas" class="contenedor-grupo-anio mb-4">
      
      <div class="d-flex justify-content-between align-items-center p-2 bg-light font-weight-bold border-bottom rounded shadow-sm mb-2">
        <span class="h5 mb-0 text-dark fw-bold">Año {{ grupo.anio }}</span>
        <span class="fs-5 fw-bold text-green">
          {{ grupo.totalAnio | currency:'EUR':'symbol':'1.2-2':'es-ES' }}
        </span>
      </div>

      <article *ngFor="let compra of grupo.meses" class="contenedor-mes mb-2">
        <div class="tarjeta-compra p-3" [class.cargando]="compra.busy">
          <div class="d-flex justify-content-between align-items-center pointer" (click)="togglePanel(compra)">
            <div class="bloque-izquierdo">
              <div class="icono-compra"><i class="fa-regular fa-calendar-days"></i></div>
              <div>
                {{compra.aniomes | periodoFecha}}
                <div class="small text-secondary">{{compra.numero}} compras</div>
              </div>
            </div>
            <div>
              <span class="label-compras-total">{{compra.total | currency:'EUR':'symbol':'1.2-2':'es-ES'}}</span>
            </div>
          </div>

          <div class="contenedor-animado" [class.abierto]="compra.panelAbierto">
            <div class="contenido-interno">
              <section class="seccion-lista">
                
                <article *ngFor="let itemCompra of compra.compras" class="contenedor-mes border-bottom p-2">
                  <div class="d-flex justify-content-between pointer" (click)="togglePanelCompra(itemCompra)">
                    <div class="bloque-izquierdo">
                      <div>
                        <img class="avatar-usuario" [src]="itemCompra.foto">
                      </div>
                      <div>
                        {{itemCompra.li_obs}}
                        <div class="small text-secondary">{{itemCompra.numero_productos}} productos</div>
                      </div>
                    </div>
                    <div class="text-end">
                      <div class="text-principal">{{itemCompra.li_fecha | cuandoFechas:'superCorto'}}</div>
                      <div class="text-green fw-bold">{{itemCompra.total | currency:'EUR':'symbol':'1.2-2':'es-ES'}}</div>
                    </div>
                  </div>

                  <div class="contenedor-animado" [class.abierto]="itemCompra.panelAbierto">
                    <div class="contenido-interno">
                      <article *ngFor="let producto of itemCompra.productos" class="contenedor-mes small mt-1 ms-4">
                        <div class="d-flex justify-content-between">
                          <div class="bloque-izquierdo">
                            <i class="fa-solid fa-cube text-secondary"></i> {{producto.pr_producto}}                          
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>

                </article>
              </section>
            </div>
          </div>

          <div *ngIf="compra.busy" class="spinner-contenedor">
            <div class="spinner-border text-principal" role="status">
                <span class="visually-hidden">Cargando...</span>
            </div>
          </div>

        </div>
      </article>

    </div>
  </section>
</main>